<template>
  <el-dialog
    visible
    :title="$t('project.inviteMember.dialog.title')"
    :class="[b(), b(activeComponents)]"
    :close-on-click-modal="false"
    append-to-body
    top="10vh"
    @opened="init()"
    @close="close"
  >
    <UserUpdateTips
      v-if="showProductWarnTips"
      :need-buy-count="importMemberCount"
      :active-components="activeComponents"
    />
    <el-tabs
      v-model="activeComponents"
      :class="b('content-tabs')"
    >
      <template v-for="item in tabComponents">
        <el-tab-pane
          v-if="item.show"
          :key="item.key"
          :name="item.key"
          :lazy="true"
        >
          <span slot="label">
            <em :class="[item.icon, b('tab-icon')]" />
            <span>{{ item.label }}</span>
          </span>
          <component
            :is="item.component"
            :ref="item.key"
            :active="activeComponents"
            :is-administrator="isAdministrator"
            :is-project="isProject"
            @hide="close"
            @change="$emit('change')"
            @updateImportMemberCount="updateImportMemberCount"
          />
        </el-tab-pane>
      </template>
    </el-tabs>
  </el-dialog>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import { mapGetters } from 'vuex';
import UserUpdateTips from 'common-module/src/components/OrganizeInviteMember/UserUpdateTips';
import { isPrivateVersion } from 'common-module/src/util';

export default {
  name: 'ProjectInviteMember',
  components: {
    UserUpdateTips
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultTab: {
      type: String,
      default: 'inviteOrgMember'
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      activeComponents: 'inviteOrgMember',
      isProject: true,
      importMemberCount: 0
    };
  },
  computed: {
    ...mapGetters('user', ['roleCodes', 'getMemberNum']),
    // 是否拥有管理权限【管理员/组织拥有者】
    isAdministrator() {
      const adminCode = ['organizationOwner', 'organizationAdmin', 'projectOwner', 'projectAdmin'];
      return adminCode.some(code => this.roleCodes.includes(code));
    },
    isOrgAdmin() {
      const adminCode = ['organizationOwner', 'organizationAdmin'];
      return adminCode.some(code => this.roleCodes.includes(code));
    },
    tabComponents() {
      return [
        {
          key: 'inviteOrgMember',
          icon: 'zkicon iconzuzhiyaoqing',
          label: this.$t('project.inviteMember.dialog.inviteOrgMember'),
          component: () => import('./inviteOrgMember'),
          show: true
        }, {
          key: 'inviteDirectAdd',
          icon: 'zkicon iconrenyuanguanli',
          label: this.$t('org.memberApply.directAdd'),
          component: () => import('./DirectAddMember'),
          show: this.isOrgAdmin
        }, {
          key: 'inviteEmail',
          icon: 'zkicon iconyoujianyaoqing',
          label: this.$t('project.inviteMember.dialog.outmember'),
          component: () => import('./inviteEmail'),
          show: !this.isOrgAdmin
        }, {
          key: 'inviteTeamLink',
          icon: 'zkicon iconlianjie',
          label: this.$t('org.memberApply.inviteTeamLink'),
          component: () => import('common-module/src/components/OrganizeInviteMember/InviteTeamLink'),
          show: !isPrivateVersion
        }
      ];
    },
    showProductWarnTips() {
      return this.activeComponents !== 'inviteOrgMember' && this.getMemberNum.totalNum <= this.getMemberNum.usedNum;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.activeComponents = this.tabComponents.find(item => item.key === this.defaultTab)?.key || 'inviteOrgMember';
    },
    close() {
      this.$emit('close');
    },
    updateImportMemberCount(count) {
      this.importMemberCount = count;
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(project-invite-member) {
  display: block;
  ::v-deep .el-dialog {
    max-width: 1000px !important;
    width: 1000px;
    .el-dialog__body {
      overflow: hidden;
      max-height: calc(100vh - 15vh - 50px - 50px);
      padding-top: 0;
      padding-bottom: 20px;
    }
  }
  @include e(content-tabs) {
    @include e(tab-icon) {
      margin-right: 5px;
    }
    ::v-deep {
      .el-tabs__item {
        &.is-active {
          em {
            color: var(--primary-color);
          }
        }
        &:hover {
          &,
          .zkicon {
            color: var(--primary-color);
          }
        }
      }
      .el-tabs__header {
        margin: 0 0 12px;
      }
    }
  }
  @include e(init-show-out-member) {
    color: var(--font-color-2);
    margin-bottom: 10px;
    display: block;
  }
}
</style>
